export default "__VITE_ASSET__v3qmImsv__"